import { useSelector } from "react-redux";
import store from "../../stores/store";
import { useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { key, trans } from "../../lib/utils";
import DatatableResults from "./DatatableResults";
import FavoritesResults from "./FavoritesResults";
import LayerResults from "./LayerResults";
import SpatialResults from "./SpatialResults";
import FeatureInfoResults from "./FeatureInfoResults";
import TimeDimensionPlayer from "./TimeDimensionPlayer";
import MeasurementResults from "./MeasurementResults";
import EditPanel from "./EditPanel";
import CSWResults from "./CSWResults";

function ResultsPanel() {
  const results = useSelector((state) => store.getState().results);
  const measurementResults = useSelector(
    (state) => store.getState().map.measurements
  );
  const timeDimension = useSelector((state) => store.getState().timeDimension);

  const activeTab = results.resultsPanelActiveTab;
  const favoriteIds = useSelector(
    (state) => store.getState().results.favoriteResultsFeatureIds
  );

  useEffect(() => {}, [favoriteIds]);

  return (
    <div className="results-panel">
      <PerfectScrollbar style={{ height: "45px" }}>
        <ul className="nav nav-tabs navbar-expand small">
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("layersResults") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "layersResults",
                });
              }}
            >
              <span className="color-black">
                {trans("Layers results").concat(
                  " (",
                  Object.keys(results.layersResults)?.length,
                  ")"
                )}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("spatialResults") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "spatialResults",
                });
              }}
            >
              <span className="color-black">
                {trans("Spatial results").concat(
                  " (",
                  Object.keys(results.spatialResults)?.length,
                  ")"
                )}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("datatableResults") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "datatableResults",
                });
              }}
            >
              <span className="color-black">
                {trans("Datatable results").concat(
                  " (",
                  Object.keys(results.dataTableResults)?.length,
                  ")"
                )}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("favoriteResults") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "favoriteResults",
                });
              }}
            >
              <span className="color-black">
                {trans("Favorites").concat(
                  " (",
                  Object.keys(results.favoriteResults)?.length,
                  ")"
                )}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("featureInfoResults") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "featureInfoResults",
                });
              }}
            >
              <span className="color-black">
                {trans("Feature Info").concat(
                  " (",
                  Object.keys(results.featureInfoResults)?.length,
                  ")"
                )}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("cswResults") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "cswResults",
                });
              }}
            >
              <span className="color-black">
                {results?.cswResults
                  ? trans("CSW results").concat(
                      " (",
                      Object.keys(results.cswResults)?.length,
                      ")"
                    )
                  : ""}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("timeDimension") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "timeDimension",
                });
              }}
            >
              <span className="color-black">
                {trans("Time dimension").concat(
                  " (",
                  Object.keys(timeDimension.layers)?.length,
                  ")"
                )}
              </span>
            </span>
          </li>
          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("measurements") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "measurements",
                });
              }}
            >
              <span className="color-black">
                {trans("Measurements").concat(
                  " (",
                  Object.keys(measurementResults)?.length,
                  ")"
                )}
              </span>
            </span>
          </li>

          <li className="nav-item " role="button">
            <span
              className={"nav-link color-strong-grey nav-ellipsis  ".concat(
                activeTab.startsWith("edit") ? "active" : ""
              )}
              onClick={() => {
                store.dispatch({
                  type: "results/setActiveTab",
                  payload: "edit",
                });
              }}
            >
              <span className="color-black">{trans("Edit panel")}</span>
            </span>
          </li>
        </ul>
      </PerfectScrollbar>
      <div className="tab-content ">
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("layersResults") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"layersResults"}
        >
          <LayerResults></LayerResults>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("spatialResults") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"spatialResults"}
        >
          <SpatialResults></SpatialResults>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("datatableResults") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"datatableResults"}
        >
          <DatatableResults></DatatableResults>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("favoriteResults") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"favoriteResults"}
        >
          <FavoritesResults></FavoritesResults>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("featureInfoResults") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"featureInfoResults"}
        >
          <FeatureInfoResults></FeatureInfoResults>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("cswResults") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"cswResults"}
        >
          <CSWResults></CSWResults>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("timeDimension") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"timeDimension"}
        >
          <TimeDimensionPlayer></TimeDimensionPlayer>
        </div>

        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("measurements") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"measurements"}
        >
          <MeasurementResults></MeasurementResults>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab.startsWith("edit") ? "show active" : ""
          )}
          role="tabpanel"
          aria-labelledby={"edit"}
        >
          <EditPanel></EditPanel>
        </div>
      </div>
    </div>
  );
}

export default ResultsPanel;
